import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const EyeOffIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M9.9 4.24c.688-.161 1.393-.242 2.1-.24 7 0 11 8 11 8-.607 1.136-1.33 2.205-2.16 3.19m-6.72-1.07c-.275.295-.606.531-.974.695-.368.164-.765.252-1.168.26-.403.007-.803-.068-1.176-.218-.374-.151-.713-.376-.998-.66-.285-.286-.51-.625-.66-.999-.151-.373-.225-.773-.218-1.176.007-.403.095-.8.259-1.168.164-.368.4-.7.695-.974m8.06 8.06C16.23 19.243 14.15 19.965 12 20c-7 0-11-8-11-8 1.244-2.318 2.97-4.343 5.06-5.94l11.88 11.88zM1 1l22 22"
    />
  </svg>
);
